import { apiServer } from 'settings/web-services/api';

export function requestGetTeamAndOwnerDetails(teamId: string) {
  return apiServer.get(`/admin-panel/teams/${teamId}/owner`);
}
